import { pegarConteudo } from "componentes/editor/seletores";
import { iniciarEditor, limparEditor } from "componentes/editor/actions";
import { exibirMensagem, exibirErros } from "componentes/mensagem/actions";

export const ATUALIZAR_DECISAO = "decisao/ATUALIZAR_DECISAO";
export const LIMPAR_DECISAO = "decisao/LIMPAR_DECISAO";
export const ADICIONAR_SITUACOES = "decisao/ADICIONAR_SITUACOES";

export const adicionarSituacoes = situacoes => dispatch => dispatch({ type: ADICIONAR_SITUACOES, situacoes });

export const adicionarDecisao = decisao => dispatch => {
  dispatch(limparEditor("decisao"));
  dispatch({ type: ATUALIZAR_DECISAO, decisao });
  dispatch(iniciarEditor("decisao", decisao.texto));
}

export const salvar = (evento, history) => (dispatch, getState) => {
  evento.preventDefault();
  const {
    decisao: {
      decisao: {
        situacao
      }
    },
    processo: {
      processo: {
        id: processoId,
        situacao: { descricao: situacaoProcesso }
      }
    }
  } = getState();

  const dados = {
    situacao,
    texto: pegarConteudo(getState(), "decisao")
  };

  const urlDecisao = `/services/api/processos/${processoId}/registrar-decisao`;

  fetch(urlDecisao, {
    method: "put",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(dados)
  })
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(decisao => {
      dispatch(exibirMensagem({ msg: "Decisão salva com sucesso", tipo: "success" }));
      history.push(`/processo/${processoId}/tramitar/${situacaoProcesso}`);
    })
    .catch(erros => dispatch(exibirErros(erros)));
}


export const buscarDependencias = (processoId, history) => (dispatch, getState) => {
  const { processo: { fase } } = getState().processo;


  if (!fase) {
//    dispatch(exibirMensagem({ msg: "Ops! lascou", tipo: "success" }));
    return history.push(`/processo/${processoId}/tramitar`);
  }


  const urlSituacoes = `/services/api/situacoes-decisao/${fase.id}/fase`;

  return fetch(urlSituacoes)
    .then(rs => rs.ok ? rs.json() : Promise.reject(rs))
    .then(situacoes => dispatch({ type: ADICIONAR_SITUACOES, situacoes }))
    .catch(erros => dispatch(exibirErros(erros)));
}


export const quandoMudar = ({ target: { name, value: valor } }) => dispatch => {
  const [prefixo, campo] = name.split("_");
  if (prefixo === "decisao") return dispatch(quandoMudarDecisao(campo, valor));
}

const quandoMudarDecisao = (campo, valor) => dispatch => {
  switch (campo) {
    case "situacaoId": {
      dispatch({ type: ATUALIZAR_DECISAO, decisao: { situacao: { id: parseInt(valor, 10) } } });
      break;
    }
    default:
      dispatch({ type: ATUALIZAR_DECISAO, decisao: { [campo]: valor } });
      break;
  }
}


// WEBPACK FOOTER //
// ./src/paginas/decisao/actions.js